import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../../components/BaseComponent';
import { Button } from '../../../../components/Buttons';
import { generateIncomingInvoice, generateOutgoingInvoice, setVehicleProperties } from '../../actions';
import { Cell, List, Row } from '../../../../components/List';
import { Card } from '../../../../components/Card';
import { OutgoingInvoiceInputModal } from './outgoingInvoiceInputModal';
import { Checkbox } from '../../../../components/Checkbox';
import { HBox } from '../../../../components/Box';
import { formatAmount } from '../../helpers';

const Container = styled.div``;

const STATE = {
  renderOutgoingInvoiceInput: false,
};

function HBOx(props) {
  return null;
}

HBOx.propTypes = { children: PropTypes.node };

/* eslint-disable react/prefer-stateless-function */
class VehicleInvoicesComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {}

  renderAttachedIncomingInvoice() {
    return this.props.vehicle.incoming_invoice ? (
      <Link onClick={this.tofn(`/invoices/incoming/${this.props.vehicle.incoming_invoice}`)}>
        {this.lbl('vehicle.details.showInvoice')} (id - {this.props.vehicle.incoming_invoice}))
      </Link>
    ) : (
      <Button disabled={this.getValue('incoming_invoice_in_helga')} onClick={this.props.generateIncomingInvoice.bind(this)}>
        {this.lbl('vehicle.details.generateIncomingInvoiceBtn')}
      </Button>
    );
  }

  renderAttachedOutgoingInvoice() {
    return this.props.vehicle.outgoing_invoice ? (
      <Link onClick={this.tofn(`/invoices/outgoing/${this.props.vehicle.outgoing_invoice}`)}>
        {this.lbl('vehicle.details.showInvoice')} (id - {this.props.vehicle.outgoing_invoice}))
      </Link>
    ) : (
      <Button disabled={true} onClick={this.toggleGenerateInvoiceInput.bind(this)}>
        {this.lbl('vehicle.details.generateOutgoingInvoiceBtn')}
      </Button>
    );
  }

  toggleGenerateInvoiceInput() {
    this.setState((prev, props) => {
      return { ...prev, renderOutgoingInvoiceInput: !prev.renderOutgoingInvoiceInput };
    });
  }

  generateOutgoingInvoice(input) {
    this.toggleGenerateInvoiceInput();
    this.props.generateOutgoingInvoice(input);
  }

  renderOutgoingInvoiceInput() {
    if (!this.state.renderOutgoingInvoiceInput) return '';

    return (
      <OutgoingInvoiceInputModal
        vehicleId={this.props.vehicle.id}
        vehicle_purpose={this.props.vehicle.vehicle_purpose}
        onConfirm={this.generateOutgoingInvoice.bind(this)}
        onClose={this.toggleGenerateInvoiceInput.bind(this)}
      />
    );
  }

  getValue(field) {
    if (this.state[field] !== undefined) return this.state[field];
    return this.props?.vehicle[field] === '1';
  }

  incomingInvoiceInHelgaToggle() {
    const currentValue = this.getValue('incoming_invoice_in_helga');
    const newValue = currentValue ? '0' : '1';
    this.props.patch([
      {
        propertyName: 'incoming_invoice_in_helga',
        propertyValue: newValue,
      },
    ]);
    this.setState({ incoming_invoice_in_helga: newValue === '1' });
  }

  outgoingInvoiceInHelgaToggle() {
    const currentValue = this.getValue('outgoing_invoice_in_helga');
    const newValue = currentValue ? '0' : '1';
    // TO SELL
    let status = 0;
    if (newValue === '1') {
      // SOLD
      status = 3;
    }
    this.props.patch([
      {
        propertyName: 'outgoing_invoice_in_helga',
        propertyValue: newValue,
      },
      {
        propertyName: 'status',
        propertyValue: status,
      },
    ]);
    this.setState({ outgoing_invoice_in_helga: newValue === '1' });
  }

  render() {
    return (
      <React.Fragment>
        <Card className="vehicle-info-card info-card data">
          <Container>
            <h2>{this.lbl('vehicle.info.data.title')}</h2>
            <List>
              <Row key={1}>
                <Cell>{this.lbl('vehicle.details.incomingInvoiceLbl')}</Cell>
                <Cell>{this.renderAttachedIncomingInvoice()}</Cell>
              </Row>
              <Row key={2}>
                <Cell>{this.lbl('vehicle.details.outgoingInvoiceLbl')}</Cell>
                <Cell>{this.renderAttachedOutgoingInvoice()}</Cell>
              </Row>
            </List>
          </Container>
          <Container>{this.renderOutgoingInvoiceInput()}</Container>
        </Card>
        <Card className="vehicle-info-card info-card data">
          <h2>{this.lbl('vehicle.info.data.invoices_in_autoflex')}</h2>
          <HBox>
            <Checkbox
              key={'incoming_invoice_in_helga'}
              checked={this.getValue('incoming_invoice_in_helga')}
              onChange={this.incomingInvoiceInHelgaToggle.bind(this)}
            >
              <h2>{this.lbl('vehicle.info.data.incoming_invoice_in_autoflex')}</h2>
            </Checkbox>
          </HBox>
          <HBox>
            <Checkbox
              key={'outgoing_invoice_in_helga'}
              checked={this.getValue('outgoing_invoice_in_helga')}
             
            >
              <h2>{this.lbl('vehicle.info.data.outgoing_invoice_in_autoflex')}</h2>
            </Checkbox>
          </HBox>
        </Card>
      </React.Fragment>
    );
  }
}

VehicleInvoicesComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    generateIncomingInvoice() {
      dispatch(generateIncomingInvoice(ownProps.vehicle.id));
    },
    generateOutgoingInvoice(input) {
      input = formatFinancialAmounts(input);
      dispatch(generateOutgoingInvoice(ownProps.vehicle.id, input));
    },
    patch(props, callback) {
      dispatch(setVehicleProperties(ownProps.vehicle.id, props, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleInvoices = compose(withConnect, withRouter)(VehicleInvoicesComp);

const formatFinancialAmounts = function(input) {
  if (input?.outgoingRestBpm) input.outgoingRestBpm = formatAmount(input.outgoingRestBpm);

  if (input?.salesAmounts) {
    for (let key in input.salesAmounts) {
      input.salesAmounts[key] = formatAmount(input.salesAmounts[key]);
    }
  }

  return input;
};
